import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";

import { title } from "utils";

import { Header } from "components";
import { Button } from "antd";

class E404Page extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>{title("Erreur")}</Helmet>

        <div className="home-page main-content">
          <Header title="Page introuvable" />
          <div className="error-display">
            <p>Cette page ne semble pas exister ...</p>
            <Button href="#/" icon="home" type="primary" size="large">
              Retour à l'accueil
            </Button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default E404Page;
